<script>
import EnterAddress from "./EnterAddress";
import PinConfirmation from "./PinConfirmation";
import SelectDistrict from "./SelectDistrict";
import DataConfirmation from "./DataConfirmation";
import SetNameAndCreate from "./SetNameAndCreate";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    accountable: {
      type: Object,
      required: true
    }
  },

  components: {
    EnterAddress,
    PinConfirmation,
    SelectDistrict,
    DataConfirmation,
    SetNameAndCreate
  },

  computed: {
    ...mapState("newAddress", ["district"])
  },

  data() {
    return {
      step: 0
    };
  },

  methods: {
    ...mapActions("newAddress", ["setAddressable"]),

    next() {
      if (this.step < 3) this.step++;
    },
    prev() {
      if (this.step > 0) this.step--;
    },

    created(address) {
      this.$emit("created", address);
      this.$emit("close");
    }
  },

  mounted() {
    this.setAddressable(this.accountable);
  }
};
</script>

<template>
  <transition name="fade" mode="out-in">
    <enter-address v-if="step === 0" @next="next" @close="$emit('close')" />
    <pin-confirmation v-else-if="step === 1" @next="next" @prev="prev" />
    <select-district
      v-else-if="step === 2 && !district"
      @next="next"
      @prev="prev"
    />
    <data-confirmation v-else-if="step === 2" @next="next" @prev="prev" />
    <set-name-and-create v-else @prev="prev" @created="created($event)" />
  </transition>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/Index.vue